import React from "react";
import { Icon, type IconName } from "@/components/ui-components/icon";

const categoryIcons: Record<string, IconName> = {
    beverages: "cart",
    "instant-food": "receipt",
    "rice-noodles": "package",
    snacks: "heart",
    household: "settings",
    "personal-care": "user",
};

export function CategoryIcon({ categoryId }: { categoryId: string }) {
    return <Icon name={categoryIcons[categoryId] ?? "package"} size="sm" />;
}